import React, { useState, Fragment } from 'react';
import { SlideLayout } from './SlideLayout';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Slide3_System() {
  const [selectedStep, setSelectedStep] = useState<number | null>(null);
  const steps = [{
    name: 'Attract',
    desc: ['Right pond', 'Right bait', 'Right people']
  }, {
    name: 'Engage',
    desc: ['Applicants apply for 12 companies in 5 minutes', 'Job boards are ran like Tinder']
  }, {
    name: 'Screen',
    desc: ['Do they fit the archetype?']
  }, {
    name: 'Qualify',
    desc: ['Do they understand the role?', 'Do they want the role?', 'Do they have the capacity to succeed?']
  }, {
    name: 'Interview',
    desc: ['Status, authority, and abundance']
  }, {
    name: 'Commit',
    desc: ['Not just saying yes, but saying no to everything else']
  }, {
    name: 'Onboard',
    desc: ['Company is impressive', 'Process is fast and professional']
  }, {
    name: 'Integrate',
    desc: ['Building trust and confidence', 'Minimum viable dose']
  }, {
    name: 'Train',
    desc: ['Tools and scripts for baseline ability']
  }, {
    name: 'Launch',
    desc: ['Significant emotional, mental, and technical experience', 'Build momentum through early rejection']
  }, {
    name: 'Retain',
    desc: ['The "never-ending game"', 'Casting vision, coaching people, developing leaders']
  }];
  return <SlideLayout className="!max-w-none !px-0" data-id="element-149" data-mp="33m14l51k505r">
      <div className="flex flex-col h-full justify-center items-center space-y-12 relative" data-id="element-150" data-mp="2ykk4vcut7jqr">
        <div className="text-center space-y-6 max-w-4xl px-4" data-id="element-151" data-mp="3dhkzpp8arutg">
          <h2 className="text-4xl md:text-6xl font-bold text-white leading-tight" data-id="element-152" data-mp="3dfqc235n5olo">
            High-Growth Companies Don't "Hire."
            <br data-id="element-153" data-mp="3fmpynry4c9pt" />
            <span className="text-[#7FE0C3]" data-id="element-154" data-mp="3fn94wbeep9o0">
              They Run a Recruiting System.
            </span>
          </h2>
          <p className="text-xl text-slate-400" data-id="element-155" data-mp="3kluayrgcankd">
            Predictable recruiting isn't about volume. It's about control across
            every step.
          </p>
        </div>

        {/* Steps Visual - Full Width */}
        <div className="w-full px-8 overflow-x-auto pb-8 scrollbar-hide" data-id="element-156" data-mp="3ucx9pmlsqqgh">
          {/* Desktop: Single horizontal line - Full width */}
          <div className="hidden md:flex items-center justify-center mx-auto py-8" data-id="element-157" data-mp="75mu7gqnf6fu">
            {steps.map((step, idx) => <Fragment key={step.name} data-id="element-158" data-mp="c60qy2msutyk" data-mpi={idx}>
                <motion.div className="flex flex-col items-center group relative cursor-pointer" initial={{
              scale: 0.8,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              delay: idx * 0.05 + 0.2
            }} whileHover={{
              scale: 1.15,
              y: -8
            }} onClick={() => setSelectedStep(idx)} data-id="element-159" data-mp="h4kda45b27rg">
                  <div className={`
                      w-20 h-20 rounded-full flex items-center justify-center 
                      transition-all duration-300 shadow-xl relative z-10 border-2
                      ${selectedStep === idx ? 'bg-[#7FE0C3]/10 border-[#7FE0C3] ring-2 ring-[#7FE0C3]/20' : 'bg-slate-900 border-slate-700 group-hover:border-[#7FE0C3]/50'}
                    `} data-id="element-160" data-mp="1wob9bt0h0fz7">
                    {/* Revolving Arrow for Retain step - positioned on circle edge */}
                    {step.name === 'Retain' && <motion.div className="absolute inset-0 pointer-events-none" animate={{
                  rotate: 360
                }} transition={{
                  duration: 6,
                  repeat: Infinity,
                  ease: 'linear'
                }} data-id="element-161" data-mp="13yul77jvvl8s">
                        {/* Arrow positioned at top edge of the circle */}
                        <div className="absolute -top-2 left-1/2 -translate-x-1/2" data-id="element-162" data-mp="3bjjlutjse441">
                          <div className="w-4 h-4 rotate-0" data-id="element-163" data-mp="3bhp05d0oy7yw">
                            <svg viewBox="0 0 12 12" fill="none" className="w-full h-full" data-id="element-164" data-mp="3ghbfbs02xyac">
                              <path d="M6 1 L9 6 L6 11 L3 6 Z" fill="#7FE0C3" stroke="#7FE0C3" strokeWidth="0.5" data-id="element-165" data-mp="36ivlvidkycxo" />
                            </svg>
                          </div>
                        </div>
                      </motion.div>}

                    <span className={`text-xs font-bold tracking-wide text-center px-1 leading-tight ${selectedStep === idx ? 'text-[#7FE0C3]' : 'text-white'}`} data-id="element-166" data-mp="8ay0p0ubdtmd">
                      {step.name}
                    </span>
                  </div>
                  <span className={`mt-3 text-sm font-medium transition-colors ${selectedStep === idx ? 'text-[#7FE0C3]' : 'text-slate-600'}`} data-id="element-167" data-mp="3qkgp2ewn5vjv">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                </motion.div>

                {idx < steps.length - 1 && <motion.div className="flex items-center mx-2" initial={{
              scaleX: 0,
              opacity: 0
            }} animate={{
              scaleX: 1,
              opacity: 1
            }} transition={{
              delay: idx * 0.05 + 0.25
            }} data-id="element-168" data-mp="36y282rgki3b9">
                    <ArrowRight className="w-5 h-5 text-slate-700" data-id="element-169" data-mp="1fmxmtm04fc69" />
                  </motion.div>}
              </Fragment>)}
          </div>

          {/* Mobile: Grid Layout */}
          <div className="md:hidden grid grid-cols-2 gap-4 max-w-sm mx-auto" data-id="element-170" data-mp="mzl27hditefl">
            {steps.map((step, idx) => <motion.div key={step.name} className={`
                  flex flex-col items-center p-4 rounded-lg border transition-all cursor-pointer
                  ${selectedStep === idx ? 'bg-[#7FE0C3]/10 border-[#7FE0C3]' : 'bg-slate-900/50 border-slate-800'}
                `} onClick={() => setSelectedStep(idx)} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: idx * 0.05
          }} data-id="element-171" data-mp="wvo3kl0jt91h" data-mpi={idx}>
                <span className="text-xs text-slate-500 mb-1" data-id="element-172" data-mp="3o02j3y01a6et">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <span className={`font-bold ${selectedStep === idx ? 'text-[#7FE0C3]' : 'text-white'}`} data-id="element-173" data-mp="3e4hb9j8aabx5">
                  {step.name}
                </span>
              </motion.div>)}
          </div>
        </div>

        {/* Description Panel */}
        <div className="w-full min-h-[140px] flex items-start justify-center px-4" data-id="element-174" data-mp="304gcqafhrgku">
          <AnimatePresence mode="wait" data-id="element-175" data-mp="13bwjr9d5wrmu">
            {selectedStep !== null ? <motion.div key={selectedStep} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} className="bg-slate-900/80 backdrop-blur-sm border border-slate-800 rounded-xl p-6 max-w-3xl w-full shadow-2xl" data-id="element-176" data-mp="139tuwsnqx4jp">
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-4" data-id="element-177" data-mp="2eeirn2h2r6d">
                  <span className="bg-[#7FE0C3] text-[#163A5F] text-sm font-bold px-3 py-1 rounded-full" data-id="element-178" data-mp="3koqf25fhvonl">
                    Step {selectedStep + 1}
                  </span>
                  <h3 className="text-2xl font-bold text-white" data-id="element-179" data-mp="3aq0wsbjos26t">
                    {steps[selectedStep].name}
                  </h3>
                </div>
                <div className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-180" data-mp="18wbapbjsbnyr">
                  {steps[selectedStep].desc.map((item, i) => <div key={i} className="flex items-center text-slate-300" data-id="element-181" data-mp="1dve767lp8lv4" data-mpi={i}>
                      <div className="w-1.5 h-1.5 rounded-full bg-[#7FE0C3] mr-3 shrink-0" data-id="element-182" data-mp="2yf06kzhttc4t" />
                      <span className="text-base" data-id="element-183" data-mp="2tfn9zn15kqp1">{item}</span>
                    </div>)}
                </div>
              </motion.div> : <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} className="flex items-center justify-center h-full text-slate-500 text-sm italic" data-id="element-184" data-mp="33dbfn80arilz">
                Select a step to view details
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </SlideLayout>;
}